import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getInvDropdown = createAsyncThunk(
  "invoiceUpload/getInvDropdown",
  async (dealCategoryId, { rejectWithValue }) => {
    try {
      const params = {};
      if (dealCategoryId) params.dealCategoryId = dealCategoryId;
      const response = await axios.get("/api/business/getInvDropdown", { params });
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const invValidate = createAsyncThunk(
  "invoiceUpload/invValidate",
  async (invList, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/business/deals/validate/invoice-financing", invList);
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const scfValidate = createAsyncThunk(
  "invoiceUpload/scfValidate",
  async (invList, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/business/deals/validate/supply-chain", invList);
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const invUpload = createAsyncThunk(
  "invoiceUpload/invUpload",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/business/deals/invoice-financing", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const scfUpload = createAsyncThunk(
  "invoiceUpload/scfUpload",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/business/deals/supply-chain", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const invoiceUploadSlice = createSlice({
  name: "invoiceUpload",
  initialState: {
    loading: false,
    validateLoading: false,
    invoiceSubmitLoading: false,
    entList: [],
    error: "",
    success: "",
  },

  extraReducers: (builder) => {
    builder.addCase(getInvDropdown.fulfilled, (state, action) => {
      state.entList = action.payload;
    });

    builder.addCase(invValidate.pending, (state) => {
      state.validateLoading = true;
      state.error = "";
    });
    builder.addCase(invValidate.fulfilled, (state, action) => {
      state.validateLoading = false;
      state.success = action.payload;
      state.error = "";
    });
    builder.addCase(invValidate.rejected, (state, action) => {
      state.validateLoading = false;
      state.error = action.payload;
    });

    builder.addCase(invUpload.pending, (state) => {
      state.invoiceSubmitLoading = true;
      state.error = "";
    });
    builder.addCase(invUpload.fulfilled, (state, action) => {
      state.invoiceSubmitLoading = false;
      state.error = "";
    });
    builder.addCase(invUpload.rejected, (state, action) => {
      state.invoiceSubmitLoading = false;
      state.error = action.payload;
    });

    builder.addCase(scfValidate.pending, (state) => {
      state.validateLoading = true;
      state.error = "";
    });
    builder.addCase(scfValidate.fulfilled, (state, action) => {
      state.validateLoading = false;
      state.success = action.payload;
      state.error = "";
    });
    builder.addCase(scfValidate.rejected, (state, action) => {
      state.validateLoading = false;
      state.error = action.payload;
    });

    builder.addCase(scfUpload.pending, (state) => {
      state.invoiceSubmitLoading = true;
      state.error = "";
    });
    builder.addCase(scfUpload.fulfilled, (state, action) => {
      state.invoiceSubmitLoading = false;
      state.error = "";
    });
    builder.addCase(scfUpload.rejected, (state, action) => {
      state.invoiceSubmitLoading = false;
      state.error = action.payload;
    });
  },

  reducers: {
    updateSuccessStatus(state) {
      state.success = "";
    },
    updateErrorStatus(state) {
      state.error = "";
    },
  },
});

export const { updateSuccessStatus, updateErrorStatus } =
  invoiceUploadSlice.actions;

export default invoiceUploadSlice.reducer;

